/* eslint-disable object-curly-newline */
import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import getProductsWithTotal from '../../../api/graphql/queries/getProductsWithTotal';
import productRemove from '../../../api/graphql/mutations/productRemove';

import Filter from '../../Tabs/Filter';
import ProductsTable from './ProductsTable';
import Toolbar from './ProductsToolbar';
// import ProductsForm from './ProductsForm';
import ProductsFormOnlyShow from './ProductsFormOnlyShow';
import Modal from '../../Modal/Modal';
import LoadIcon from '../../LoadIcon';

const ProductsContainer = () => {
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isCreateModalOn, setIsCreateModalOn] = useState(false);
  const [isDisplayModalOn, setIsDisplayModalOn] = useState(false);
  const [isModifyModalOn, setIsModifyModalOn] = useState(false);
  const [isDeleteModalOn, setIsDeleteModalOn] = useState(false);
  const [formOutput, setFormOutput] = useState({});
  const [currItemData, setCurrItemData] = useState([]);
  const [toggleDeleteInfoScreen, setToggleDeleteInfoScreen] = useState([]);
  const [total, setTotal] = useState(0);
  const [query, setQuery] = useState('');
  const [reloadData, setReloadData] = useState(false);

  // Filtering items:
  const [slugName, setSlugName] = useState(null);
  const [productGroup, setProductGroup] = useState(null);
  const [productType, setProductType] = useState(null);
  const [createdAt, setCreatedAt] = useState(null);
  const [deleted, setDeleted] = useState(null);

  // Sorting items:
  const [sorting, setSorting] = useState(['createdAt', -1]);

  // Pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [previousPage, setPreviousPage] = useState(0);
  const [avoidEffect, setAvoidEffect] = useState(false);

  const toggleCreateModal = () => {
    setIsCreateModalOn(!isCreateModalOn);
  };

  const toggleDisplayModal = (item) => {
    setIsDisplayModalOn(!isDisplayModalOn);
    setCurrItemData(filteredData.find(el => el._id === item));
  };

  const toggleModifyModal = (item) => {
    setIsModifyModalOn(!isModifyModalOn);
    setCurrItemData(filteredData.find(el => el._id === item));
  };

  const toggleDeleteModal = (item) => {
    setIsDeleteModalOn(!isDeleteModalOn);
    setCurrItemData(filteredData.find(el => el._id === item));
  };

  const formOutputHandler = (value) => {
    setFormOutput(value);
    // we would send this to the DB to create an entry
  };

  const deleteProduct = async (event) => {
    const { currentTarget: { id, attributes: { 'data-deleted': { value: deletedProduct } = {} } } } = event;
    if (deletedProduct === 'true') {
      // eslint-disable-next-line no-alert
      if (window.confirm('¿Restore product?')) {
        const res = await productRemove({ productId: id, restore: true });
        if (res) {
          setReloadData(new Date());
        }
      }
      return;
    }

    // eslint-disable-next-line no-alert
    if (window.confirm('Delete product?')) {
      const res = await productRemove({ productId: id });
      if (res) {
        setReloadData(new Date());
      }
    }
  };

  const editProduct = async (event) => {
    const { currentTarget: { id } } = event;
    handleClick('modify', id);
    // eslint-disable-next-line no-alert
  };

  const columns = [
    { field: '_id', headerName: 'productId', type: 'string', sortable: true, align: 'left', hide: true, isId: true },
    { field: null, headerName: '', type: 'action', align: 'left', content: ((rowData, idValue) => (<span id={idValue} className="font-icon icon-edit text-20" onClick={editProduct} title="Edit product" />)) },
    { field: 'slugName', headerName: 'slugName', type: 'string', sortable: true, align: 'left' },
    { field: 'productGroup', headerName: 'productGroup', type: 'string', sortable: true, align: 'left', conditionalClassName: (rowData => (rowData.deletedAt && 'line-through')) },
    { field: 'subscriptionLength', headerName: 'subscriptionLength', type: 'string', sortable: true, align: 'right' },
    { field: 'subscriptionDays', headerName: 'subscriptionDays', type: 'string', sortable: true, align: 'left' },
    { field: 'title.en', headerName: 'title', type: 'string', sortable: true, align: 'left' },
    { field: 'amount', headerName: 'amount', type: 'string', sortable: true, align: 'right' },
    { field: 'currency', headerName: 'currency', type: 'string', sortable: true, align: 'right' },
    { field: 'productType', headerName: 'productType', type: 'string', sortable: true, align: 'left' },
    { field: 'productPresent', headerName: 'productPresent', type: 'boolean', sortable: true, align: 'left' },
    { field: 'createdAt', headerName: 'createdAt', type: 'date', sortable: true, align: 'left' },
    { field: 'deletedAt', headerName: 'deleted', type: 'boolean', sortable: true, align: 'left' },
    { field: null, headerName: '', type: 'action', align: 'left', content: ((rowData, idValue) => (<span id={idValue} data-deleted={!!rowData.deletedAt} className={`font-icon icon-trash text-20 ${rowData.deletedAt ? 'text-blue' : 'text-red'}`} onClick={deleteProduct} title="Delete product" />)) },
  ];


  const handleClick = (action, item) => {
    switch (action) {
      case 'create':
        toggleCreateModal();
        break;
      case 'display':
        toggleDisplayModal(item);
        break;
      case 'modify':
        toggleModifyModal(item);
        break;
      case 'delete':
        toggleDeleteModal(item);
        break;
      case 'closeDeleteItem':
        setToggleDeleteInfoScreen(!toggleDeleteInfoScreen);
        break;
      default:
        console.log('wrong action!');
        break;
    }
  };

  useEffect(() => {
    if (avoidEffect) {
      console.log('Avoiding effect');
      return;
    }
    let from = page * rowsPerPage;
    let to = (page + 1) * rowsPerPage;
    if (previousPage === page) {
      setAvoidEffect(true);
      setPage(0);
      from = 0;
      to = rowsPerPage;
    } else {
      from = page * rowsPerPage;
      to = (page + 1) * rowsPerPage;
      setPreviousPage(page);
    }
    console.log('Calling getProductsWithTotal()');
    getProductsWithTotal({
      slugName,
      productGroup,
      productType,
      deleted,
      from,
      to,
      sortingField: sorting[0],
      sortingType: sorting[1],
    }).then((productsDataObject) => {
      if (productsDataObject) {
        if (productsDataObject.isAuth) {
          setTotal(productsDataObject.total);
          setQuery(productsDataObject.query);
          setFilteredData(productsDataObject.products);
          setIsLoading(false);
        } else {
          console.log('getProductsWithTotal failed!');
        }
      } else {
        console.log('productsData = null');
      }
      setAvoidEffect(false);
    });
  }, [
    slugName,
    productGroup,
    productType,
    deleted,
    page,
    rowsPerPage,
    sorting,
    reloadData,
  ]);

  // const updateSearch = (val) => {
  //   setFilterText(val);
  //   setFilteredData(initialItems.filter(item => item.email.toLowerCase().includes(val.toLowerCase())));
  // };

  return (
    <Fragment>
      <div className="w-full bg-white">
        <div className="flex justify-between mb-4">
          <span className="text-americaMonoBold text-26">Products</span>
          <span className="font-americaMonoBold text-14 uppercase">
            Total:
            {total}
          </span>
          {/* <button
            type="button"
            className="font-americaMonoBold text-xs px-6 rounded-full bg-black text-white uppercase"
            onClick={() => {
              handleClick('create');
            }}
          >
            Create User
          </button> */}
        </div>
        {isDisplayModalOn && (
          <Modal title="Display Product" handleClick={handleClick} type="display">
            <ProductsFormOnlyShow handleClick={handleClick} formInput={currItemData} action="display" />
          </Modal>
        )}
        {isModifyModalOn && (
          <Modal title="Modify Subscription" handleClick={handleClick} type="modify">
            {/* <ProductsFormModify handleClick={handleClick} retrieveOutput={formOutputHandler} formInput={currItemData[0]} action="modify" /> */}
          </Modal>
        )}
        <div className="mt-4">
          {!isLoading ? (
            <>
              <Toolbar
                // setHasBadge={setHasBadge}
                setSlugName={setSlugName}
                setProductGroup={setProductGroup}
                setProductType={setProductType}
                deleted={deleted}
                setDeleted={setDeleted}
              />
              <ProductsTable
                tableData={filteredData}
                columns={columns}
                // handleClick={handleClick}
                total={total}
                page={page}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                sorting={sorting}
                setSorting={setSorting}
              />
              <div style={{ color: '#fff' }}>
                {query}
              </div>
            </>
          ) : <LoadIcon />}
        </div>
      </div>
    </Fragment>
  );
};

ProductsContainer.propTypes = {
};

export default withRouter(ProductsContainer);
